import api from "@/api.js";
import { NFCScan } from "@/plugins/NFC.js";

export default {
  namespaced: true,
  state: {
    nfcScanner: null,
    handleReading: null,
  },
  mutations: {
  },
  actions: {
    async startScanner({ state }, { $this, handleNFCScan }) {
      try {
        state.nfcScanner.removeEventListener("reading", state.handleReading);
      } catch (error) {
        console.log(error);
      }
      console.log("Scanning NFC");

      const { ndef, handleReading } = await NFCScan(
        $this,
        handleNFCScan,
        null
      );

      state.nfcScanner = ndef;
      state.handleReading = handleReading;

    },

    async nfcReconcile({ dispatch }, payload) {
      let returnData = {};
      try {
        let response = await api
          .post(`associations/members/NFCTags/reconcile`, payload)
        if (response.data.Result == "Success") {
          returnData = {
            Result: "Success",
            Response: response.data
          };
        } else {
          returnData = {
            Result: "Failed",
            Response: response.data
          };
        }
      } catch (error) {
        returnData = {
          Result: "Error",
          Response: {
            Message: "There was an Error, Please try again later"
          }
        };
      }



      return returnData;

    },
  },
  getters: {
  }
};
